import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PrlDashboardComponent} from './components/prl-dashboard/prl-dashboard.component';
import {PrlDashboardRoutingModule} from "./prl-dashboard-routing.module";
import {PrlDashboardGraphComponent} from "./components/prl-dashboard-graph/prl-dashboard-graph.component";
import {PrlDashboardTopZonesComponent} from "./components/prl-dashboard-top-zones/prl-dashboard-top-zones.component";
import {PrlDashboardMessagesComponent} from "./components/prl-dashboard-messages/prl-dashboard-messages.component";
import {
    PrlDashboardMonthlyCommissionComponent
} from "./components/prl-dashboard-monthly-commission/prl-dashboard-monthly-commission.component";
import {PrlNewMessageComponent} from "./components/prl-dashboard-messages/prl-new-message/prl-new-message.component";
import {
    PrlMessageDialogComponent
} from "./components/prl-dashboard-messages/prl-message-dialog/prl-message-dialog.component";
import {
    MxButtonModule,
    MxCarouselModule,
    MxFormModule,
    MxInfoTooltipModule,
    MxPreloaderModule,
    MxSharedModule,
    MxThumbnailModule
} from "mx-core";
import {HighchartsChartComponent} from "highcharts-angular";
import {NgxPaginationModule} from "ngx-pagination";
import {PrlLanguageModule} from "../prl-language/prl-language.module";
import {MatFormField, MatLabel} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {ReactiveFormsModule} from "@angular/forms";
import {MatCard} from "@angular/material/card";
import {
    PrlDashboardReferFriendComponent
} from "./components/prl-dashboard-refer-friend/prl-dashboard-refer-friend.component";
import {PrlDashboardTopZoneComponent} from "./components/prl-dashboard-top-zone/prl-dashboard-top-zone.component";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
    declarations: [
        PrlDashboardComponent,
        PrlDashboardGraphComponent,
        PrlDashboardMessagesComponent,
        PrlDashboardMonthlyCommissionComponent,
        PrlDashboardReferFriendComponent,
        PrlDashboardTopZoneComponent,
        PrlDashboardTopZonesComponent,
        PrlMessageDialogComponent,
        PrlNewMessageComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        MxPreloaderModule,
        PrlDashboardRoutingModule,
        PrlLanguageModule,
        MxButtonModule,
        HighchartsChartComponent,
        MxFormModule,
        MxSharedModule,
        MatFormField,
        MatLabel,
        MatSelect,
        MatOption,
        ReactiveFormsModule,
        MatCard,
        MxInfoTooltipModule,
        MxThumbnailModule,
        MxCarouselModule,
        NgxPaginationModule,
        TranslateModule
    ]
})
export class PrlDashboardModule { }
